export function renderBuildLoadingSkeletonSourceGeneratedFunctionTemplate({
  componentName,
  escapeJsx
}: {
  componentName: string
  escapeJsx: string
}): string {
  return `export function ${componentName}() {
  return (
    <div className="flex items-center justify-center h-48">
      <div className="text-muted-foreground">Loading ${escapeJsx}…</div>
    </div>
  )
}
`
}
